import { render } from "./PermReviewModal.vue?vue&type=template&id=3f65a0b4&scoped=true"
import script from "./PermReviewModal.vue?vue&type=script&lang=js"
export * from "./PermReviewModal.vue?vue&type=script&lang=js"

import "./PermReviewModal.vue?vue&type=style&index=0&id=3f65a0b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f65a0b4"],['__file',"src/views/components/PermReviewModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f65a0b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f65a0b4', __exports__)) {
    api.reload('3f65a0b4', __exports__)
  }
  
  module.hot.accept("./PermReviewModal.vue?vue&type=template&id=3f65a0b4&scoped=true", () => {
    api.rerender('3f65a0b4', render)
  })

}


export default __exports__